import React from "react";

export const Policies = () => {
    return (
        <div className="pageContentSegment">
            <h1>Policies, Terms, and Legal Stuff</h1>
            <p>The rough print and the fine print. We try to make all our policies as clear, fair, and readable as possible.</p>
            <h2>Terms of Service</h2>
            <p><a href={"/policies/terms"}>Link to Terms of Service</a></p>
            <p>All product and company names are trademarks or registered® trademarks of their respective holders. Use of them by Liked Songs Manager does not imply any
                affiliation with or endorsement by them.</p>
            <h2>Privacy Policy</h2>
            <p><a href={"/policies/privacy-policy"}>Link to Privacy Policy</a></p>
            <p>The policy sets out the different areas where user privacy is concerned and outlines the obligations & requirements of the users, the website and website owners.
                Furthermore the way this website processes, stores and protects user data and information will also be detailed within this policy.</p>
            <h2>Refund policy</h2>
            <p><a href={"/policies/refund-policy"}>Link to Refund Policy</a></p>
            <h2>Cancellation policy</h2>
            <p><a href={"/policies/cancellation-policy"}>Link to Cancellation Policy</a></p>
            <h2>Licenses</h2>
            <p><a href={"/policies/licenses"}>Link to Licenses</a></p>
            <p>Adapted from the <a href="https://github.com/basecamp/policies">Basecamp open-source policies</a> / <a href="https://creativecommons.org/licenses/by/4.0/">CC BY
                4.0</a></p>
        </div>
    )
}